document.addEventListener("DOMContentLoaded", function() {

  // sliders
  if (window.matchMedia("(max-width: 992px)").matches) {
    document.querySelectorAll(".swiper").forEach((slider) => {
      new Swiper(slider, {
        pagination: { 
          el: slider.querySelector(".swiper-pagination"), 
          clickable: true 
        },
        slidesPerView: 1.2
      });
    });
  }

  // menu hovers
  function showMenu (packs) {
    if (packs) {
      document.querySelector('.header.b3-header').classList.add('is-open-packs');
      document.querySelector('body').classList.add('is-menu-open-packs');
    } else {
      document.querySelector('.header.b3-header').classList.add('is-open');
      document.querySelector('body').classList.add('is-menu-open');
    }

  }
  function hideMenu (packs) {
    if (packs) {
      document.querySelector('.header.b3-header').classList.remove('is-open-packs');
      document.querySelector('body').classList.remove('is-menu-open-packs');
    } else {
      document.querySelector('.header.b3-header').classList.remove('is-open');
      document.querySelector('body').classList.remove('is-menu-open');
    }

  }
  const targetMenuProducts = document.querySelector('.hover-megamenu');
  const targetMenuProductsContainer = document.querySelector('.b3-section-header-megamenu');

  if (window.innerWidth > 992) {
    if (targetMenuProducts) {
      targetMenuProducts.addEventListener('mouseenter', () => {
        showMenu();
      });
      targetMenuProductsContainer.addEventListener('mouseenter', () => {
        showMenu();
      });
    
      targetMenuProducts.addEventListener('mouseleave', () => {
        hideMenu();
      });
      targetMenuProductsContainer.addEventListener('mouseleave', () => {
        hideMenu();
      });
    }
  } else {
    if (targetMenuProducts) {
      targetMenuProducts.querySelector("a").addEventListener("click", function(event) {
        event.preventDefault();
        document.querySelector('body').classList.toggle('open-mobile-menu')
      });

      const linksMobileMenu = document.querySelectorAll('.b3-section-header-megamenu-tabs a');
    
      linksMobileMenu.forEach(function (link) {
        link.addEventListener('click', function (event) {
          if (!link.href.includes('/all')) {
            
          }
          event.preventDefault();
        });
      });
    }
  }

  // only packs
  const targetMenuPacks = document.querySelector('.hover-megamenu-packs');
  const targetMenuPacksContainer = document.querySelector('.b3-section-header-megamenu-packs');
  
  if (window.innerWidth > 992) {
    if (targetMenuPacks) {
      targetMenuPacks.addEventListener('mouseenter', () => {
        showMenu(true);
      });
      targetMenuPacksContainer.addEventListener('mouseenter', () => {
        showMenu(true);
      });
    
      targetMenuPacks.addEventListener('mouseleave', () => {
        hideMenu(true);
      });
      targetMenuPacksContainer.addEventListener('mouseleave', () => {
        hideMenu(true);
      });
    }
  }


  // inner megamenu
  const targetMenuCategories = document.querySelectorAll('.b3-section-header-megamenu-tabs a');
  if (targetMenuCategories) {
    targetMenuCategories.forEach(container => {
      container.addEventListener('mouseenter', (e) => {
        const rel = e.target.getAttribute('target-rel')
        if (rel == 'Todos') {

          setTimeout( () => {
            if (window.innerWidth > 992) {
              $('.slider-menu-all').slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 1,
                      dots: false,
                      arrows: true
                    }
                  }
                ]
              });
            }
          }, 10 );

        }

        if (window.innerWidth < 992) {
          const categoryButton = document.querySelector('#link-by-category')
          if (categoryButton) {
            if (rel == 'Packs') {
              categoryButton.setAttribute('href', '/collections/packs-con-suscripcion')
            }
            if (rel == 'Granolas') {
              categoryButton.setAttribute('href', '/collections/granola')
            }
            if (rel == 'Barritas') {
              categoryButton.setAttribute('href', '/collections/barritas')
            }
            if (rel == 'Crema') {
              categoryButton.setAttribute('href', '/collections/crema')
            }
          }

        }

        const activeTab = document.querySelector('.b3-section-header-megamenu-tabs a.active');
        const activeElement = document.querySelector('.b3-section-header-megamenu-items--anchor.active');
        if (activeTab) activeTab.classList.remove('active')
        if (activeElement) activeElement.classList.remove('active')
        
        e.target.classList.add('active')
        const elementToActive = `div[destination-rel="${rel}"]`
        const domElementToActive = document.querySelector(elementToActive);
        if (domElementToActive) domElementToActive.classList.add('active');
        
      });
    });
  }

  // product page
  const customSelect = document.getElementById('customSelect');
  const customSelectSticky = document.getElementById('customSelectSticky');

  if (customSelect) {
    const selected = customSelect.querySelector('.selected');
    const options = customSelect.querySelectorAll('.option');
    customSelect.addEventListener('click', () => {
      customSelect.classList.toggle('open');
    });
  
    options.forEach(option => {
      option.addEventListener('click', (e) => {
        selected.querySelector('span').textContent = e.target.textContent;
        setTimeout(() => {
          customSelect.classList.remove('open');
        }, 100);
      });
    });
  }

  if (customSelectSticky) {
    const selected = customSelectSticky.querySelector('.selected');
    const options = customSelectSticky.querySelectorAll('.option');
    customSelectSticky.addEventListener('click', () => {
      customSelectSticky.classList.toggle('open');
    });
  
    options.forEach(option => {
      option.addEventListener('click', (e) => {
        selected.querySelector('span').textContent = e.target.textContent;
        setTimeout(() => {
          customSelectSticky.classList.remove('open');
        }, 100);
      });
    });
  }

  const customVariantsSelector = document.querySelector('.selected-variant-option');
  
  /*
  if (customVariantsSelector && customVariantsSelectorOptions) {
    const optionsSelector = document.querySelectorAll('.template-product .custom-variants .product-form__input label');

    optionsSelector.forEach(option => {
      option.addEventListener('click', (e) => {
        console.log("select", e.target)
        setTimeout(() => {
          customVariantsSelectorOptions.classList.toggle('show-options');
        }, 100);
      });
    });
  }
  */

  
  document.addEventListener('click', function (event) {
    if (event.target.closest('.selected-variant-option') || event.target.closest('.selected-variant-option-selected')) {
      const customVariantsSelectorOptions = document.querySelector('.template-product .custom-variants .product-form__input');
      const optionsSelector = document.querySelectorAll('.template-product .custom-variants .product-form__input label');

      setTimeout(() => {
        customVariantsSelectorOptions.classList.add('show-options');
      }, 100);


      optionsSelector.forEach(option => {
        option.addEventListener('click', (e) => {
          setTimeout(() => {
            window.location.reload();
          }, 800);
        });
      });

      
    }
  });


  document.addEventListener('click', (e) => {
    if (customSelect) {
      if (!customSelect.contains(e.target)) {
        customSelect.classList.remove('open');
      } 
    }
    if (customSelectSticky) {
      if (!customSelectSticky.contains(e.target)) {
        customSelectSticky.classList.remove('open');
      }
    }

    const customVariantsSelectorOptions = document.querySelector('.template-product .custom-variants .product-form__input');
    if (customVariantsSelectorOptions) {
      if (!customVariantsSelectorOptions.contains(e.target)) {
        customVariantsSelectorOptions.classList.remove('show-options');
      }
    }
  });

  const startVariant = document.querySelector('.template-product .product-variant-id')
  const labelCurrentVar = document.querySelector('.selected-variant-option-selected')
  if (startVariant) {
    const varId = document.querySelector('.template-product .product-variant-id').value
    const selectedVariant = window.current_product.variants.find(v => v.id == Number(varId));

    if (labelCurrentVar) {
      labelCurrentVar.innerText = selectedVariant.title
    }
    


    const colorAdder = document.querySelector('.selected-variant-option .variant-color')
    if (colorAdder) {
      if (selectedVariant.title.includes('Cacao')) {
        colorAdder.classList.add('brawn')
      }
      if (selectedVariant.title.includes('Arándanos')) {
        colorAdder.classList.add('blue')
      }
      if (selectedVariant.title.includes('Cacahuete')) {
        colorAdder.classList.add('yellow')
      }
      if (selectedVariant.title.includes('Variety')) {
        colorAdder.classList.add('variety')
      }
    }
    
  }

});


document.addEventListener('DOMContentLoaded', function() {
    function updateFreeShippingBar() {
      const freeShippingThreshold = 3500;
      const shippingMessage = document.querySelector('.free-shipping-message-dynamic');
      const shippingProgress = document.querySelector('.free-shipping-progressl-dynamic');
      const numberCart = document.querySelector('#number-cart');
      const labelNumberCart = document.querySelector('#label-number-cart');
      const drawer__header = document.querySelector('.drawer__header');
      const cartShakeContent = document.querySelector('.b3-header .header__icon--cart .svg-wrapper')
      
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartTotal = cart.total_price; // en centavos
          const percentage = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
          const totalItems = cart.items.reduce((acc, item) => acc + item.quantity, 0);
          shippingProgress.style.width = `${percentage}%`;

          if (drawer__header) {
            drawer__header.classList.add('loaded')
          }

          if (numberCart && labelNumberCart) {
            numberCart.innerHTML = totalItems

            if (totalItems == 1) {
              labelNumberCart.innerHTML = 'producto'
            } else {
              if (totalItems == 0) {
                labelNumberCart.innerHTML = 'Tu carrito actualmente está vacío.'
                numberCart.innerHTML = ''
              } else {
                labelNumberCart.innerHTML = 'productos'
              }
            }

            if (cartShakeContent) {
              if (totalItems == 0) {
                // cartShakeContent.classList.remove('startAni')
              } else {
                // cartShakeContent.classList.add('startAni')
              } 
            }


            
          }

          if ((cartTotal / 100) >= 15) {
            document.querySelector('.bullet-minimal-amount').classList.add('complete')

            const payments = document.querySelector('.footer-cards-cart')
            if (payments) {
              payments.classList.remove('disable-buttons')
            }
            document.querySelector('body').classList.remove('block-purchased')

            
          } else {
            document.querySelector('.bullet-minimal-amount').classList.remove('complete')

            const payments = document.querySelector('.footer-cards-cart')
            if (payments) {
              payments.classList.add('disable-buttons')
            }

            if (window.current_product) {
              if (window.current_product.price < 1500) {
                document.querySelector('body').classList.add('block-purchased')
              }
            }
            
          }

          if (cartTotal >= freeShippingThreshold) {
            shippingMessage.innerHTML = "¡Felicidades! ¡Tienes envío gratis!";
            document.querySelector('.bullet-free-shipping').classList.add('complete')
          } else {
            const amountLeft = (freeShippingThreshold - cartTotal) / 100;
            shippingMessage.innerHTML = `Te falta <strong>${amountLeft.toFixed(2)}€</strong> para el envío standard <strong>GRATIS</strong>`;
            document.querySelector('.bullet-free-shipping').classList.remove('complete')
          }
        });
    }

    document.querySelectorAll('button[data-cart-toggle], .cart-drawer__close-button').forEach(button => {
      button.addEventListener('click', function() {
        setTimeout(updateFreeShippingBar, 500);
      });
    });

    document.addEventListener('cart:updated', updateFreeShippingBar);
    updateFreeShippingBar();

    setInterval(() => {
      updateFreeShippingBar();
    }, 1000);



  function checkCartAfterItemRemoved() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (cart.item_count === 0) {
          location.reload();
        }
      });
  }
  
  document.addEventListener('click', function(e) {
    const target = e.target;
  
    if (
      target.matches('[data-remove-item]') ||
      target.closest('.cart__remove') ||
      target.closest('button[name="minus"]')
    ) {
      setTimeout(checkCartAfterItemRemoved, 500);
    }
  });
});